import { render } from "./PendingTransfers.vue?vue&type=template&id=9976f3b4"
import script from "./PendingTransfers.vue?vue&type=script&lang=js"
export * from "./PendingTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__